import breakpoints from "../../breakpoints";
import { ComponentsOverrides, Theme } from "@mui/material";

const dialog = (): ComponentsOverrides<Theme>["MuiDialog"] => ({
    root: {
        "&.dialog-side-right": {
            marginRight: 0,

            "& .MuiDialog-container": {
                justifyContent: "flex-end",
                marginRight: 0,
            },
            "& .MuiDialog-paper": {
                maxHeight: "100%",
                height: "100%",
                margin: 0,
                borderRadius: 0,
            },
        },
    },
    paper: {
        padding: "0",
        width: "auto",
        borderRadius: "1.6rem",
        boxShadow: "none",
        "& form": {
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            flexGrow: 1,
        },
        [`@media (max-width:${breakpoints.values.md - 0.05}px)`]: {
            "&&": {
                width: "auto",
            },
        },
    },
    paperFullScreen: {
        margin: 0,
        maxWidth: "100%",
        minWidth: "100%",
        width: "100%",
        height: "auto",
        maxHeight: "100%",
        verticalAlign: "bottom",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    paperWidthSm: {
        maxWidth: "656px",
        width: " calc(100% - 64px)",
    },
    paperWidthMd: {
        maxWidth: "880px",
        width: " calc(100% - 64px)",
    },
    paperWidthLg: {
        maxWidth: "1104px",
        width: " calc(100% - 64px)",
    },
    paperWidthXl: {
        maxWidth: "1440px",
        width: " calc(100% - 64px)",
    },
});

export default dialog;
